import { Button as MuiButton, ButtonProps } from '@mui/material'

export function Button(props: ButtonProps) {
  return <MuiButton {...props} sx={{
    borderRadius: 3,
    height: 38,
    ...props.sx
  }} />
}
